import * as React from "react";
import { Box, Container, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function PageNotFound() {
  const nav = useNavigate();
  const homeHandler = () => nav(`/`);

  return (
    <Container maxWidth="md">
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Typography variant="h4" component="h4">
            404 - Sahifa topilmadi
          </Typography>
          <Button
            variant="contained"
            color="primary"
            onClick={homeHandler}
            sx={{ mt: 2 }}
          >
            Bosh sahifa
          </Button>
        </Box>
      </Box>
    </Container>
  );
}
